module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "block bg-white c-black footer"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: "/"
      }
    }
  }, [_c('module-logo', {
    attrs: {
      "small": true
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "footer__nav"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      key: link.id,
      staticClass: "footer__list"
    }, [_c('module-link', {
      staticClass: "footer__link ttu tdn fw-extrabold link",
      attrs: {
        "color": "secondary",
        "link": link.slug,
        "label": link.name,
        "external": link.external ? link.external : false
      }
    })], 1)
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4120d3dc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Footer.vue
// module id = 230
// module chunks = 0